/**
 * Reprocess Action
 * Re-processes a file (admin only)
 */

import { Datum } from "../datastructure";
import { ActionDefinition, ActionContext, getFilePayload } from "./types";
import reprocessFileService from "@/components/FpAppV4/services/reprocessFile";

/**
 * Reprocess a file
 */
export async function reprocessFile(
  datum: Datum,
  context: ActionContext
): Promise<void> {
  const payload = getFilePayload(datum);
  if (!payload) {
    console.error("reprocessFile: Cannot reprocess non-file datum");
    return;
  }

  // Confirm with user
  const confirmed = window.confirm(
    `Are you sure you want to reprocess "${payload.fileName}"?\n\nThis will re-extract and re-index the document.`
  );
  if (!confirmed) return;

  try {
    context.showToast?.(`Reprocessing "${payload.fileName}"...`, "info");

    await reprocessFileService(payload.fileId);

    context.refreshTree();

    context.showToast?.(
      `Reprocessing started for "${payload.fileName}"`,
      "success"
    );
  } catch (error) {
    console.error("reprocessFile: Failed to reprocess file", error);
    context.showToast?.(`Failed to reprocess "${payload.fileName}"`, "error");
  }
}

/**
 * Action definition for context menu
 * Note: This should only be shown to admin users - the isApplicable check
 * should be enhanced with user permission checking in the parent component
 */
export const reprocessAction: ActionDefinition = {
  config: {
    action: "reprocess",
    label: "Reprocess",
  },
  isApplicable: (datum) => datum.type === "file",
  execute: reprocessFile,
};
